
import { defineComponent, ref } from "vue";
import UploaderDataFilterComponent from "@/components/uploader/UploaderDataFilter.component.vue";
import UploaderDataListComponent from "@/components/uploader/UploaderDataList.component.vue";
import UploaderDataListManualComponent from "@/components/uploader/UploaderDataListManual.component.vue";
import { Pagination } from "@/types/pagination.type";
import {
  getDataWithCleanningAutomatic,
  getvisualizeTrainingData,
  postTrainingData,
  updateTrainingData,
} from "@/service/trainingData.service";
import ElMessage from "element-plus/lib/components/message";
import { SamplingPointOffline, UploaderDataFilter } from "@/types/samplingPointOffline.type";
import { TrainingData } from "@/types/trainingData.type";
import { getSamplingPointImages, addImageTrainingRelationsMassive } from "@/service/image.service";
import moment from "moment";
import { getContainerSamplingPoints } from "@/service/samplingpoint.service";
import { Filter } from "@/types/filter.type";

export default defineComponent({
  components: {
    UploaderDataFilterComponent,
    UploaderDataListComponent,
    UploaderDataListManualComponent,
  },
  data() {
    return {
      trainingData: [] as TrainingData[],
      rowPerPage: 10 as number,
      totalRows: 0 as number | undefined,
      currentPage: 0 as number,
      dataPagination: {} as Pagination<SamplingPointOffline>,
      formUpload: {} as UploaderDataFilter,
      loading: false,
      loadingUpload: false,
      assingLabels: false,
      uploadType: ref("automatic"),
      samplingPoints: [] as any[],
      selectedSamplingPointId: null as number | null,
      customLoading: {
        show: false,
        text: "",
      },
    };
  },
  methods: {
    async handleSubmit() {
      const filterRef = this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>;

      await filterRef.valdidate();
      this.loading = true;

      try {
        const data = await filterRef.handleSubmit();
        if (!data) {
          ElMessage.error(this.$t("error.notUpload"));
          return;
        }

        const cleanSaica = await getDataWithCleanningAutomatic(data);
        if (!cleanSaica) return;

        this.trainingData = cleanSaica;

        const formData = filterRef.uploaderDataFilter || (this.formUpload as any) || {};
        if (!formData?.container?.id) return;

        const points = await getContainerSamplingPoints(formData.container.id);
        this.samplingPoints = (points || []).filter(
          (p) => p.container?.id === formData.container.id
        );
        this.selectedSamplingPointId = null;

        if (this.samplingPoints.length === 1) {
          this.selectedSamplingPointId = this.samplingPoints[0].id;
        }

        ElMessage.success(this.$t("success.load"));
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async handleSubmitOld() {
      await (this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>)
        .valdidate()
        .then(() => {
          this.loading = true;
        });
      await (this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>)
        .handleSubmit()
        .then(async (data: any) => {
          if (data) {
            await getDataWithCleanningAutomatic(data)
              .then((cleanSaica) => {
                if (cleanSaica) {
                  this.trainingData = cleanSaica;
                  this.loading = false;
                  ElMessage.success(this.$t("success.load"));
                }
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            ElMessage.error(this.$t("error.notUpload"));
          }
        });
    },

    async uploadData() {
      await (
        this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>
      ).checkNewSPType();
      postTrainingData(this.trainingData)
        .then(() => {
          this.loadingUpload = false;
          ElMessage.success(this.$t("success.user"));
        })
        .catch(() => {
          this.loadingUpload = false;
        });

      this.assingLabels = true;
    },

    async handleSubmitManual() {
      await (this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>)
        .valdidate()
        .then(() => {
          this.loading = true;
        });
      await (this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>)
        .handleSubmitManual()
        .then(async (data: TrainingData[]) => {
          if (data) {
            this.loading = false;
            this.trainingData = data as TrainingData[];
            this.loadingUpload = false;
            ElMessage.success(this.$t("success.user"));
          }
        })
        .catch(() => {
          this.loadingUpload = false;
          ElMessage.error(this.$t("error.any"));
        });
    },

    removeData() {
      this.trainingData = [];
    },

    async updateData() {
      this.loadingUpload = false;
      try {
        await (
          this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>
        ).checkNewSPType();
        await updateTrainingData(this.trainingData);
        this.loadingUpload = false;
        ElMessage.success(this.$t("success.user"));
      } catch (error) {
        console.error(error);
        this.loadingUpload = false;
      }

      this.trainingData = [];
    },

    async assignImageLabels() {
      if (!this.selectedSamplingPointId) return ElMessage.warning("Selecciona un punto");
      const filterRef = this.$refs["filter"] as InstanceType<typeof UploaderDataFilterComponent>;
      const formData = filterRef?.uploaderDataFilter || (this.formUpload as any) || {};
      if (!formData?.container?.id) return ElMessage.warning("Selecciona un contenedor");
      if (!this.trainingData || this.trainingData.length === 0)
        return ElMessage.warning("No hay datos");

      this.customLoading.show = true;
      this.customLoading.text = "Preparando datos...";

      try {
        const timeValues = this.trainingData.map((s: any) => moment(s.dateTime).valueOf());
        const uniqueCodes = [
          ...new Set(this.trainingData.map((s: any) => s.codeParameter?.code).filter(Boolean)),
        ];
        const minTime = Math.min(...timeValues);
        const maxTime = Math.max(...timeValues);

        const filter: Filter = {
          fields: {
            "trainingData.container": { operator: "equal", value: formData.container.id },
            "trainingData.dateTime": {
              operator: "between",
              value: [new Date(minTime).toISOString(), new Date(maxTime).toISOString()],
            },
            "trainingData.codeParameter": { operator: "in", value: uniqueCodes },
            "trainingData.origin": {
              operator: "equal",
              value: filterRef?.uploaderDataFilter.origin,
            },
          },
        };

        const response = await getvisualizeTrainingData(undefined, undefined, filter);
        const samplesWithId = (response.data ?? []).filter((s: any) => s.id && s.dateTime);

        if (samplesWithId.length === 0) {
          this.customLoading.show = false;
          return ElMessage.warning("No se encontraron muestras guardadas");
        }

        const ONE_HOUR_MS = 60 * 60 * 1000;
        const startStr = new Date(minTime - ONE_HOUR_MS).toISOString();
        const endStr = new Date(maxTime + ONE_HOUR_MS).toISOString();

        let allImages: any[] = [];
        let currentPage = 1;
        let totalRows = 0;

        this.customLoading.text = "Buscando imágenes...";

        do {
          const imgRes = await getSamplingPointImages(
            this.selectedSamplingPointId.toString(),
            currentPage,
            100,
            startStr,
            endStr
          );
          if (imgRes.data) allImages = allImages.concat(imgRes.data);
          totalRows = imgRes.totalRows ?? 0;
          currentPage++;
        } while (allImages.length < totalRows && totalRows > 0);

        const tasks: Array<() => Promise<any>> = [];

        for (const img of allImages) {
          const imgTime = moment(img.dateTime).valueOf();
          const relatedSamples = samplesWithId.filter(
            (sample: any) => Math.abs(moment(sample.dateTime).valueOf() - imgTime) <= ONE_HOUR_MS
          );

          if (relatedSamples.length > 0) {
            const sinteticos = relatedSamples
              .filter((s: any) => s.origin === "SINTETICO" || s.origin === "AQUACORP")
              .map((s: any) => s.id);

            const organicos = relatedSamples
              .filter((s: any) => s.origin !== "SINTETICO" && s.origin !== "AQUACORP")
              .map((s: any) => s.id);

            if (sinteticos.length > 0 || organicos.length > 0) {
              tasks.push(() => addImageTrainingRelationsMassive(img.id, sinteticos, organicos));
            }
          }
        }

        if (tasks.length === 0) {
          this.customLoading.show = false;
          return ElMessage.info("No hay nuevas asociaciones");
        }

        let updateCount = 0;
        for (let i = 0; i < tasks.length; i++) {
          this.customLoading.text = `Asociando imagen ${i + 1} de ${tasks.length}...`;

          try {
            await tasks[i]();
            updateCount++;
          } catch (err) {
            console.error("Error en tarea:", err);
          }
        }

        if (updateCount > 0) ElMessage.success(`Se asociaron ${updateCount} imágenes.`);
      } catch (error) {
        console.error(error);
        ElMessage.error("Error en el proceso masivo");
      } finally {
        this.customLoading.show = false;
      }
    },
  },
});
